import React, { useState } from 'react';
import { Upload, Palette, Eye, Save, Globe, Lock, ChevronDown, Monitor, Smartphone, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const CURRENCIES = [{
  code: 'USD',
  label: 'US Dollar',
  symbol: '$'
}, {
  code: 'CAD',
  label: 'Canadian Dollar',
  symbol: 'C$'
}];
const LOCATIONS = [{
  code: 'US',
  label: 'United States'
}, {
  code: 'CA',
  label: 'Canada'
}];
export function BrandHub() {
  const [primaryColor, setPrimaryColor] = useState('#4F46E5');
  const [secondaryColor, setSecondaryColor] = useState('#0F172A');
  const [brandName, setBrandName] = useState('MyReseller Pro');
  const [currency, setCurrency] = useState('USD');
  const [location, setLocation] = useState('US');
  const [slaText, setSlaText] = useState('This hosting plan guarantees 99.9% uptime and 24/7 priority support...');
  return <div className="space-y-6 max-w-[1600px] mx-auto h-full flex flex-col" data-id="element-187">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-188">
        <div data-id="element-189">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-190">Brand Hub</h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-191">
            White-Label Engine: Configure your brand identity and global
            storefront settings.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-192">
          <button className="px-4 py-2.5 text-sm font-bold text-gray-600 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-193">
            Discard
          </button>
          <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-194">
            <Save size={18} data-id="element-195" />
            Publish Branding
          </button>
        </div>
      </div>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-2 gap-6 min-h-0" data-id="element-196">
        {/* Left Column: Control Panel */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm flex flex-col overflow-hidden" data-id="element-197">
          <div className="flex-1 overflow-y-auto p-8 space-y-8" data-id="element-198">
            <div className="space-y-6" data-id="element-199">
              <div className="space-y-2" data-id="element-200">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-201">
                  Brand Name
                </label>
                <input type="text" value={brandName} onChange={e => setBrandName(e.target.value)} className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500/20 outline-none transition-all font-medium" data-id="element-202" />
              </div>

              <div className="grid grid-cols-2 gap-6" data-id="element-203">
                <div className="space-y-2" data-id="element-204">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-205">
                    Light Mode Logo
                  </label>
                  <div className="border-2 border-dashed border-gray-200 rounded-lg p-6 flex flex-col items-center justify-center gap-2 hover:border-indigo-400 transition-colors cursor-pointer bg-gray-50 group" data-id="element-206">
                    <Upload size={20} className="text-gray-400" data-id="element-207" />
                    <span className="text-[10px] font-bold text-gray-400" data-id="element-208">
                      SVG/PNG
                    </span>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-209">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-210">
                    Dark Mode Logo
                  </label>
                  <div className="border-2 border-dashed border-slate-800 rounded-lg p-6 flex flex-col items-center justify-center gap-2 hover:border-indigo-400 transition-colors cursor-pointer bg-slate-900 group" data-id="element-211">
                    <Upload size={20} className="text-slate-500" data-id="element-212" />
                    <span className="text-[10px] font-bold text-slate-500" data-id="element-213">
                      SVG/PNG
                    </span>
                  </div>
                </div>
              </div>

              <div className="space-y-2" data-id="element-214">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-215">
                  Favicon (32x32)
                </label>
                <div className="flex items-center gap-4 p-4 bg-gray-50 border border-gray-200 rounded-lg border-dashed hover:border-indigo-400 cursor-pointer transition-all" data-id="element-216">
                  <div className="w-8 h-8 bg-white rounded border border-gray-200 flex items-center justify-center" data-id="element-217">
                    <Globe size={16} className="text-gray-400" data-id="element-218" />
                  </div>
                  <span className="text-xs font-bold text-gray-400" data-id="element-219">
                    Upload .ico or .png
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-6" data-id="element-220">
                <div className="space-y-2" data-id="element-221">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-222">
                    Primary Color
                  </label>
                  <div className="flex gap-2" data-id="element-223">
                    <input type="color" value={primaryColor} onChange={e => setPrimaryColor(e.target.value)} className="w-10 h-10 rounded-lg cursor-pointer border-none p-0 overflow-hidden" data-id="element-224" />
                    <input type="text" value={primaryColor} onChange={e => setPrimaryColor(e.target.value)} className="flex-1 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs font-mono font-bold" data-id="element-225" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-226">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-227">
                    Global Currency
                  </label>
                  <div className="relative" data-id="element-228">
                    <select value={currency} onChange={e => setCurrency(e.target.value)} className="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg appearance-none text-xs font-bold text-slate-900 focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-229">
                      {CURRENCIES.map(c => <option key={c.code} value={c.code} data-id="element-230">
                          {c.code} - {c.label}
                        </option>)}
                    </select>
                    <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} data-id="element-231" />
                  </div>
                </div>
              </div>

              <div className="space-y-2" data-id="element-232">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-233">
                  Target Region (US & Canada Only)
                </label>
                <div className="relative" data-id="element-234">
                  <select value={location} onChange={e => setLocation(e.target.value)} className="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg appearance-none text-xs font-bold text-slate-900 focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-235">
                    {LOCATIONS.map(l => <option key={l.code} value={l.code} data-id="element-236">
                        {l.label}
                      </option>)}
                  </select>
                  <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} data-id="element-237" />
                </div>
              </div>
            </div>

            <div className="pt-6 border-t border-gray-100" data-id="element-238">
              <div className="flex items-center justify-between mb-4" data-id="element-239">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-240">
                  SLA Manager
                </label>
                <div className="flex gap-2" data-id="element-241">
                  {['$35', '$65', '$99'].map(tier => <button key={tier} className="text-[10px] font-bold text-gray-500 bg-gray-100 px-2 py-0.5 rounded uppercase hover:bg-indigo-50 hover:text-indigo-600 transition-all" data-id="element-242">
                      {tier} Tier
                    </button>)}
                </div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm" data-id="element-243">
                <div className="flex border-b border-gray-100 p-2 gap-1 bg-gray-50/50" data-id="element-244">
                  <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:bg-white hover:text-indigo-600 hover:shadow-sm rounded transition-all font-bold text-xs" data-id="element-245">
                    B
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:bg-white hover:text-indigo-600 hover:shadow-sm rounded transition-all font-bold text-xs italic" data-id="element-246">
                    I
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:bg-white hover:text-indigo-600 hover:shadow-sm rounded transition-all font-bold text-xs underline" data-id="element-247">
                    U
                  </button>
                </div>
                <div contentEditable onBlur={e => setSlaText(e.currentTarget.textContent || '')} className="w-full h-32 p-4 text-sm focus:outline-none resize-none font-medium text-slate-600 overflow-y-auto" suppressContentEditableWarning={true} data-id="element-248">
                  {slaText}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Live Preview Frame */}
        <div className="bg-slate-900 rounded-lg border border-slate-800 shadow-2xl overflow-hidden flex flex-col" data-id="element-249">
          <div className="bg-slate-800/50 px-6 py-4 border-b border-slate-700 flex items-center justify-between" data-id="element-250">
            <div className="flex items-center gap-3" data-id="element-251">
              <div className="flex gap-1.5" data-id="element-252">
                <div className="w-3 h-3 rounded-full bg-red-500/60" data-id="element-253"></div>
                <div className="w-3 h-3 rounded-full bg-amber-500/60" data-id="element-254"></div>
                <div className="w-3 h-3 rounded-full bg-emerald-500/60" data-id="element-255"></div>
              </div>
              <div className="h-4 w-[1px] bg-slate-700 mx-2" data-id="element-256"></div>
              <div className="flex items-center gap-2" data-id="element-257">
                <Eye size={14} className="text-slate-400" data-id="element-258" />
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-259">
                  Live Preview: Customer OS
                </span>
              </div>
            </div>
            <div className="flex gap-2" data-id="element-260">
              <button className="p-1.5 text-slate-400 hover:text-white transition-colors" data-id="element-261">
                <Monitor size={16} data-id="element-262" />
              </button>
              <button className="p-1.5 text-slate-500" data-id="element-263">
                <Smartphone size={16} data-id="element-264" />
              </button>
            </div>
          </div>

          <div className="flex-1 bg-gray-50 flex overflow-hidden" data-id="element-265">
            {/* Mock Sidebar */}
            <div className="w-16 bg-slate-900 flex flex-col items-center py-6 gap-6" data-id="element-266">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-bold text-xl shadow-lg" style={{
              backgroundColor: primaryColor
            }} data-id="element-267">
                {brandName.charAt(0)}
              </div>
              <div className="space-y-4" data-id="element-268">
                {[1, 2, 3, 4].map(i => <div key={i} className={`w-8 h-8 rounded-lg ${i === 1 ? 'bg-white/10' : 'bg-transparent'} flex items-center justify-center`} data-id="element-269">
                    <div className={`w-4 h-4 rounded ${i === 1 ? 'bg-white' : 'bg-slate-700'}`} data-id="element-270"></div>
                  </div>)}
              </div>
            </div>

            {/* Mock Content */}
            <div className="flex-1 flex flex-col" data-id="element-271">
              <header className="h-14 bg-white border-b border-gray-200 flex items-center justify-between px-6" data-id="element-272">
                <div className="text-xs font-bold text-slate-900" data-id="element-273">
                  {brandName} Portal
                </div>
                <div className="flex gap-3" data-id="element-274">
                  <div className="w-8 h-8 rounded-full bg-gray-100" data-id="element-275"></div>
                </div>
              </header>
              <main className="p-6 space-y-6" data-id="element-276">
                <div className="grid grid-cols-2 gap-4" data-id="element-277">
                  <div className="h-24 bg-white rounded-lg border border-gray-200 p-4 space-y-3" data-id="element-278">
                    <div className="w-12 h-2 bg-gray-100 rounded" data-id="element-279"></div>
                    <div className="text-lg font-bold" style={{
                    color: primaryColor
                  }} data-id="element-280">
                      $2,450.00
                    </div>
                  </div>
                  <div className="h-24 bg-white rounded-lg border border-gray-200 p-4 space-y-3" data-id="element-281">
                    <div className="w-12 h-2 bg-gray-100 rounded" data-id="element-282"></div>
                    <div className="text-lg font-bold text-slate-900" data-id="element-283">
                      12 Active Sites
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-lg border border-gray-200 p-6 space-y-4" data-id="element-284">
                  <div className="flex items-center justify-between" data-id="element-285">
                    <div className="text-xs font-bold text-slate-900" data-id="element-286">
                      Service Level Agreement
                    </div>
                    <button className="px-4 py-2 rounded-lg text-white text-[10px] font-bold shadow-lg" style={{
                    backgroundColor: primaryColor
                  }} data-id="element-287">
                      Accept SLA
                    </button>
                  </div>
                  <p className="text-[10px] text-gray-500 leading-relaxed italic" data-id="element-288">
                    "{slaText}"
                  </p>
                </div>
              </main>
            </div>
          </div>

          <div className="p-4 bg-slate-800/30 border-t border-slate-700 flex items-center justify-center gap-6" data-id="element-289">
            <div className="flex items-center gap-2" data-id="element-290">
              <div className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-291"></div>
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-292">
                System Online
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-293">
              <Check size={12} className="text-indigo-400" data-id="element-294" />
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-295">
                SSL Secure
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}